import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get_company_list_detail_action, search_company_action } from "../../../redux/_actions";

function useViewCompanies(props) {
  const [loading, setLoading] = useState(false);
  const [allCompanies, setAllCompanies] = useState([]);

  //PAGINATION
  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [lastElement, setLastElement] = useState(null);
  const [newJobsLoading, setNewJobsLoading] = useState(false);
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  const [companySearch, setCompanySearch] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef = useRef();

  //get data from redux
  const { companyListData } = useSelector(
    (state) => state.get_company_list_detail_reducer
  );

  const { searchCompanyData } = useSelector(
    (state) => state.search_company_reducer 
  );

  useEffect(() => {
    setLoading(true);
    callApi();
  }, []);

  useEffect(() => {
    if (nextPage !== null) {
      setNewJobsLoading(true);
      callApi();
    }
  }, [pageNum]);

  useEffect(() => {
    if (companyListData?.data) {
      let data = companyListData.data?.results;
      let results = allCompanies;
      data.forEach((newItem) => {
        if (!results.find((item) => item.id === newItem.id)) {
          results.push(newItem);
        }
      });
      setAllCompanies(results);
      setNextPage(companyListData?.data.next);
    }
  }, [companyListData]);

  useEffect(() => {
    if (searchCompanyData?.data) {
      setCompanySearch(searchCompanyData?.data)
    }
  }, [searchCompanyData]);

  //infinite scroll pagination
  useEffect(() => {
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [lastElement]);

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0];
      if (first.isIntersecting) {
        setPageNum((no) => no + 1);
      }
    })
  );

  // get all applied jobs
  const callApi = async () => {
    await dispatch(get_company_list_detail_action(pageNum));
    setLoading(false);
    setNewJobsLoading(false);
  };

  const companyNavigation = (id) => {
    navigate(`/company-info/${id}`, {
      state: {
        companyId: id,
      },
    });
  };

  const onSearch = () => {
    if (showSearch) {
      searchInputRef.current.value = ''
    }
    setShowSearch(showSearch => !showSearch);
  }

  const onSearchInputChange = async (e) => {

    let value = e.target.value;
    if (value.length > 2) {
      setShowSearch(true);
      const data = {
        "index": "company",
        "search_key": "",
        "search": value
      }
      setCompaniesLoading(true);
      const res = await dispatch(search_company_action(data))
      setCompaniesLoading(false);
    }
  }


  return {
    loading,
    allCompanies,
    skillsTagsAdded,
    skillsListLoading,
    showSearch,
    searchInputRef,
    companiesLoading,
    companySearch,
    companyNavigation,
    onSearchInputChange,
    onSearch
  };
}
export default useViewCompanies;
